import React from 'react';
import { Button } from '@headlessui/react';
import { FaBars, FaArrowLeft } from 'react-icons/fa';
import { getUserLimits } from '../utils/tokenUtils';

const DashboardHeader = ({ 
  user, 
  sidebarOpen, 
  setSidebarOpen,
  onUpgradeClick,
  customTitle,
  showBackButton,
  onBackClick,
  rightActions
}) => {
  // Get cached user limits for plan display
  const limits = getUserLimits();
  const userPlan = limits?.plan || 'free';
  return (
    <div className="bg-black border-b border-gray-800">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden text-gray-400 hover:text-white mr-4"
            >
              <FaBars className="h-6 w-6" />
            </button>
            {showBackButton && (
              <button
                onClick={onBackClick}
                className="mr-4 p-2 text-gray-400 hover:text-white hover:bg-gray-800 rounded-lg transition-colors duration-200"
              >
                <FaArrowLeft className="w-5 h-5" />
              </button>
            )}
            <div className="flex items-center">
              <div>
                <h1 className="text-xl lg:text-3xl font-bold text-white">
                  {customTitle || `Welcome, ${user?.firstName || user?.email || 'User'}!`}
                </h1>
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            {rightActions}
            <Button
              onClick={() => {
                if (onUpgradeClick) return onUpgradeClick();
                // Fallback: dispatch global event so pages can open their own UpgradeModal
                window.dispatchEvent(new CustomEvent('open-upgrade-modal', { detail: {} }));
              }}
              className={`px-6 py-3 rounded-xl flex items-center transition-colors duration-200 data-hover:bg-gray-700 data-focus:ring-white border ${
                userPlan === 'enterprise'
                  ? 'bg-gray-800 text-white hover:bg-gray-700 border-gray-700'
                  : 'bg-gray-700 text-white hover:bg-gray-600 border-gray-600'
              }`}
            >
              {userPlan === 'free' && (
                <span>Free Plan - Upgrade Now</span>
              )}
              {userPlan === 'premium' && (
                <span>Premium Plan</span>
              )}
              {userPlan === 'enterprise' && (
                <span>Enterprise Plan</span>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
